import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';

@Injectable({
  providedIn: 'root'
})
export class RubroVendedorService {

  constructor(
    private gqlclient: GraphQLClient
  ) { }

  obtenerRubrosVendedor(inputParams: {
    entidad: {
      rut_empresa: number
      sucursal_codigo: number
      vendedor_codigo: number
    }
  }, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: rubro_vendedorInputType) {
          rubro_vendedor {
            obtenerRubrosVendedor(entidad: $entidad) {
              mensajes {
                codigo
                texto
                tipo
              }
              respuesta {
                rut_empresa
                sucursal_codigo
                vendedor_codigo
                rubro_codigo
                rubro_nombre
                asignado
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.rubro_vendedor.obtenerRubrosVendedor
        callback({ mensajes, respuesta })
      }
    );
  }

  guardarListaRubro(inputParams: {
    entidad: {
      rut_empresa: number
      sucursal_codigo: number
      vendedor_codigo: number
      listaRubroVendedor: {
        rubro_codigo: number
        asignado: boolean
      }[]
    }
  }, callback: Function) {
    this.gqlclient.mutate(
      {
        mutation: gql`
        mutation ($entidad: rubro_vendedorInputType) {
          rubro_vendedor {
            guardarListaRubro(entidad: $entidad) {
              mensajes {
                codigo
                texto
                tipo
              }
              respuesta {
                rut_empresa
                sucursal_codigo
                vendedor_codigo
                rubro_codigo
                fecha_registro
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.rubro_vendedor.guardarListaRubro
        callback({ mensajes, respuesta })
      }
    );
  }

}
